import {Fragment, useContext, useEffect} from 'react';
import {useTranslation} from 'react-i18next';

import {groupApi} from 'api';
import {PredefinedNotifierType} from 'components';
import {UserContext} from 'context';
import {useApiData} from 'hooks';
import {TRANSLATION_KEYS} from 'locale';

import {ScreenshotsManagement} from './ScreenshotsManagement';
import {UserInfoSchemaBuilder} from './UserInfoSchemaBuilder';
import {VirtualBackgroundManagement} from './VirtualBackgroundManagement';

const T_KEYS = TRANSLATION_KEYS.USER.ACCOUNT.SESSION.IN_SESSION;

export const InSession: React.FC = () => {
    const {t} = useTranslation();
    const {send: loadGroups, data: groups = []} = useApiData(groupApi.getGroups, {notificationType: PredefinedNotifierType.FetchError});
    const {settings: {featuresAvailability, userSession}} = useContext(UserContext);

    useEffect(() => {
        loadGroups();
    }, [loadGroups]);

    return (
        <Fragment>
            <div className='tw-mb-4'>{t(T_KEYS.DESCRIPTION)}</div>
            <ScreenshotsManagement groups={groups} guestEnabled={featuresAvailability.guestEnabled} />
            {userSession.virtualBackground?.enabled &&
                <VirtualBackgroundManagement />}
            {featuresAvailability.userInfoSchemaEditor &&
                <UserInfoSchemaBuilder groups={groups} guestEnabled={featuresAvailability.guestEnabled} />}
        </Fragment>
    );
};
